import {
  AfterContentInit,
  ChangeDetectorRef,
  Component, effect,
  inject,
  input,
  model, OnDestroy,
  OnInit,
  signal,
  ViewChild
} from '@angular/core';
import {ButtonComponent, ButtonOptions, ModalComponent, ModalOptions, TableComponent} from "@shared/components";
import {APIService, ToastService} from '@core/services';
import {PatientService} from '@core/services/patient.service';
import {HTTPMethods, ModalTypes} from '@core/enums';
import {HttpHeaders} from '@angular/common/http';
import {Contact} from '@core/classes/tables/contact';

@Component({
  selector: 'ncp-contact-status-action',
  imports: [
    ButtonComponent,
    ModalComponent
  ],
  templateUrl: './contact-status-action.component.html',
  styleUrl: './contact-status-action.component.scss',
})
export class ContactStatusActionComponent implements OnInit, AfterContentInit, OnDestroy {
  protected readonly toastService = inject(ToastService);
  protected readonly apiService = inject(APIService);
  protected readonly patientService = inject(PatientService);
  private readonly changeDetectorRef: ChangeDetectorRef = inject(ChangeDetectorRef);

  @ViewChild('mod') public mod!: ModalComponent;
  @ViewChild('btn') public btn!: ButtonComponent;

  protected data = model<Contact>();
  protected allData = model<Contact[]>();
  protected reloadData = model<() => {}>();
  protected index = input<number>();
  protected tbl = model<TableComponent<Contact>>(new TableComponent());

  protected btnOptions = signal<ButtonOptions>(
    new ButtonOptions({
      id: 'action'
    })
  );

  protected modOptions = model<ModalOptions>(
    new ModalOptions({
      id: 'modal',
      type: ModalTypes.confirm,
    })
  );

  statusEffect = effect(() => {
    this.setConfirm();
  });

  setConfirm = () => {
    if(this.row?.version_id?.toString() !== this.patientService.version!.new?.toString()) {
      this.modOptions().title = this.row?.status === 1 ? 'disable_entry' : 'enable_entry';
      this.modOptions().message = this.row?.status === 1 ? 'confirm_disable' : 'confirm_enable';
      this.btnOptions().icon = this.row?.status === 1 ? 'bi bi-file-earmark-minus' : 'bi bi-file-earmark-plus';
      this.btnOptions().class = '';
      this.btnOptions().tooltip = this.row?.status === 1 ? 'disable_entry' : 'enable_entry';
      this.modOptions().onYes = this.changeStatus;
    } else {
      this.modOptions().title = 'delete_entry';
      this.modOptions().message = 'confirm_delete';
      this.btnOptions().icon = 'bi bi-trash3';
      this.btnOptions().class = 'btn-danger';
      this.btnOptions().tooltip = 'delete_entry';
      this.modOptions().onYes = this.deleteEntry;
    }
  }

  ngOnInit() {
    this.btnOptions().onClick = () => {
      this.setConfirm();
      this.btn.blur();
      this.mod.open();
    };
  }

  ngOnDestroy() {
    this.statusEffect.destroy();
  }

  ngAfterContentInit() {

  }

  get row() {
    return this.data();
  }
  set row(row) {
    this.data.set(row);
  }

  protected changeStatus = () => {
    this.apiService.call({
      path: '/cp',
      headers: new HttpHeaders().set('pToken', this.patientService.pToken || ''),
      type: HTTPMethods.PUT,
      body: {
        status: this.data()?.status === 1 ? 0 : 1,
        cp_id: this.data()?.cp_id,
        version_id: this.data()?.version_id
      }
    })?.subscribe(res => {
      if(res && res.status && res.status.toString() === '1') {
        let allData = this.allData() as Contact[];
        allData[this.index()!].status = allData[this.index()!].status === 1 ? 0 : 1;
        this.row = allData[this.index()!];

        this.btnOptions().icon = this.row?.status === 1 ? 'bi bi-file-earmark-minus' : 'bi bi-file-earmark-plus';
        this.btnOptions().tooltip = this.row?.status === 1 ? 'disable_entry' : 'enable_entry';

        (this.tbl() as TableComponent<Contact>).detectChanges();

        this.mod.close('success');
      }
    });
  }

  protected deleteEntry = () => {
    this.apiService.call({
      path: '/delete-cp',
      headers: new HttpHeaders().set('pToken', this.patientService.pToken || ''),
      type: HTTPMethods.PUT,
      body: {
        cp_id: this.data()?.cp_id,
        version_id: this.data()?.version_id
      }
    })?.subscribe(res => {
      if (res && res.status && res.status.toString() === '1') {
        let allData = (this.tbl() as TableComponent<Contact>).tableData;

        (this.tbl() as TableComponent<Contact>).tableData = allData!.filter(item => {
          return !((item.cp_id?.toString() === this.data()?.cp_id?.toString()) &&
            (item.version_id?.toString() === this.data()?.version_id?.toString()))
        });

        (this.tbl() as TableComponent<Contact>).reload().detectChanges();
        this.mod.close('success');
      }
    });
  };
}
